import { Plugins } from '@capacitor/core';

const { Storage } = Plugins;

const localStore = {
  async setItem(key, value) {
    try {
      await Storage.set({
        key,
        value: JSON.stringify(value),
      });
      return key;
    } catch (e) {
      return null;
    }
  },

  async getItem(key) {
    try {
      const { value } = await Storage.get({ key });
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  },

  async removeItem(key) {
    try {
      await Storage.remove({ key });
      return key;
    } catch (e) {
      return null;
    }
  },

  async keys() {
    try {
      const { keys } = await Storage.keys();
      return keys;
    } catch (e) {
      return null;
    }
  },

  async clear() {
    try {
      await Storage.clear();
      return true;
    } catch (e) {
      return null;
    }
  },
};

export default localStore;
